import { motion } from "framer-motion";
import AppCard from "@/components/AppCard";
import { apps } from "@/data/apps";

const AppsPage = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] }
  };

  return (
    <div className="min-h-screen pt-20" data-testid="apps-page">
      {/* Header */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container-main text-center">
          <motion.div {...fadeInUp}>
            <p className="caption mb-4">Our Apps</p>
            <h1 className="heading-1 mb-4">Apps that work for you.</h1>
            <p className="body-lg max-w-2xl mx-auto">
              Discover our collection of AI-powered applications designed to solve real problems 
              and make your life better.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Apps List */}
      <section className="bg-white">
        <div className="container-main">
          {apps.map((app, index) => (
            <div key={app.id} className={index !== apps.length - 1 ? "border-b border-zinc-100" : ""}>
              <AppCard app={app} index={index} detailed />
            </div>
          ))}
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="section-spacing bg-[#F5F5F7]">
        <div className="container-main text-center">
          <motion.div {...fadeInUp}>
            <h2 className="heading-3 mb-4">Have an idea for an app?</h2>
            <p className="body-text max-w-xl mx-auto mb-8">
              We're always looking for new ways to help people with practical AI solutions. 
              Share your ideas with us.
            </p>
            <a
              href="/contact"
              className="btn-primary inline-flex items-center justify-center"
              data-testid="apps-contact-btn"
            >
              Get in Touch
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AppsPage;
